export default __webpack_public_path__ + "fonts/Rubik-Bold.ttf";